/* eslint-disable camelcase */

export enum TemplateType {
  responseTemplate = 'response_template',
  stylesheet = 'stylesheet',
  configurationPanel = 'configuration_panel'
}

export enum ProcessorFieldType {
  STRING = 'string',
  IMAGE = 'image',
  PDF = 'pdf'
}

export enum DataFieldType {
  TEXT = 'text',
  DATE = 'date',
  DATETIME = 'date_time',
  IMAGE = 'image',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
  NESTEDARRAY = 'nested_array'
}

export interface JSONSchema {
  // Correct format: { properties: { fieldName: { type: [...], items: [...] } } }
  type?: string
  $schema?: string
  properties?: Record<
    string,
    {
      type: string[]
      items: {
        type: string
        required?: string[]
        properties: Record<
          string,
          { title: string; type: string[]; key: string }
        >
      }[]
    }
  >
  // Legacy format saved by older UI versions
  items?: {
    properties: Record<string, { title: string; type: string[]; key: string }>
    type: string
    required?: string[]
  }[]
}

export interface ProcessorField {
  id: string | number
  created_at: string
  updated_at: string
  field_name: string
  portal_id: number
  data_type: ProcessorFieldType
}

export interface DataField {
  created_at?: string
  updated_at?: string
  id?: number
  name: string
  rank?: number
  data_type: DataFieldType
  dataType?: DataFieldType
  schema?: JSONSchema
  required: boolean
  dataset_path: string
  datasetPath?: string
  templateId?: number
  default_value: string
  det_template_id?: number
  merchant_evidence_id?: number
}

export interface EvidenceRule {
  id?: number
  description: string
  det_template_id?: number
  reason_code_categories?: string[]
  json_logic_ruleset?: Record<string, unknown>
}

export interface TemplateDTO {
  active?: boolean
  evidenceRules: EvidenceRule[]
  templateId: number
  overridenTemplateId: number
  content: string
  displayName: string
  merchantId: number
  name: string
  templateType: TemplateType
  hidden: boolean
  renderingExcluded: boolean
  childTemplateIds: number[]
  overridenByMerchants: string[]
  merchantsUsingGpdTemplate: string[]
  parentTemplateIds: number[]
  processorField: ProcessorField
  dataFields: DataField[]
  portal: {
    id: number
    name: string
  }
  merchantSpecific: boolean
  data_fields_attributes: Partial<DataField>[]
  updatedAt?: string
}

export interface JSONConfig {
  actions: {
    klass: Record<string, unknown>
    desc: string
    args: Record<string, unknown>
    opts: Record<string, unknown>
  }
  events: Record<string, { title: string }>
  fields: Record<string, unknown>
}
